<template>
  <form @submit.prevent="coupleWithEherkenning()" class="u-padding--30 c-card">
    <h2 class="u-color-black h2 h2--secondary">Inloggen met gebruikersnaam</h2>

    <nn-input-field
      name="username"
      id="username"
      v-model="username"
      class="u-margin-bottom"
      :readonly="passwordResetFlow"
    >
      Gebruikersnaam
      <span v-if="!passwordResetFlow"
        >(<a :href="config.forgotUsername"><u>vergeten?</u></a
        >)</span
      >
    </nn-input-field>

    <nn-input-field
      name="password"
      id="password"
      type="password"
      v-model="password"
      class="u-margin-bottom"
      @keydown="onKeydown($event)"
      @keydown-enter="askForConfirmation"
      :hint="capsLockInfo"
      @blur="capsLockInfo = ''"
    >
      Wachtwoord
      <span v-if="!passwordResetFlow"
        >(<router-link :to="{ name: 'ResetPassword', params: { config } }"
          ><u>aanvragen of vergeten?</u></router-link
        >)</span
      >
    </nn-input-field>

    <nn-notification
      v-if="invalidFormError"
      type="warning"
      class="u-margin-bottom"
    >
      Vul de juiste gegevens in (maximaal 3 keer) of kies voor
      <a :href="config.forgotUsername">gebruikersnaam</a> of
      <router-link :to="{ name: 'ResetPassword', params: { config } }"
        >wachtwoord aanvragen of vergeten?</router-link
      >
    </nn-notification>

    <div class="u-margin-top--30">
      <nn-button
        name="accountSamenvoegen"
        @click="askForConfirmation"
        class="u-margin-bottom"
        data-test="accountSamenvoegen"
        >Account koppelen</nn-button
      >
      <nn-button
        variant="secondary"
        @click="redirectToHome"
        data-test="stopKoppelen"
        >Stoppen met koppelen</nn-button
      >
    </div>

    <nn-modal ref="confirmCoupling">
      <nn-spinner v-if="loading" class="u-margin-top--30"></nn-spinner>
      <div v-else>
        <h3>Bevestig het samenvoegen van je accounts</h3>
        <p>
          We voegen je account <strong>{{ username }}</strong> samen met je
          eHerkenning-account. Let op: je kunt voortaan alleen inloggen met
          eHerkenning.
        </p>
        <p>Ja, ik wil voortaan eenvoudig en veilig inloggen met eHerkenning:</p>
        <nn-button
          @click="coupleWithEherkenning"
          class="u-margin-right--15"
          data-test="modalAccountSamenvoegen"
          >Account samenvoegen</nn-button
        >
        <nn-button
          variant="secondary"
          @click="closeModal"
          data-test="modalAnnuleren"
          >Annuleren</nn-button
        >
      </div>
    </nn-modal>
  </form>
</template>

<script>
import * as api from "../api";
import { redirect } from "@nn/psdl-utility/src/redirect";
import { forgeRockCodes } from "../amResponseCodes";

const FAILED_ATTEMPTS_BEFORE_REDIRECT = 3;

export default {
  name: "Home",
  props: {
    config: {
      type: Object,
      default: () => ({})
    },
    passwordResetFlow: {
      type: Boolean,
      default: false
    },
    usernameFromResetPassword: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      username: "",
      password: "",
      invalidFormError: "",
      loading: false,
      capsLockInfo: "",
      failedLoginAttempts: 0
    };
  },
  mounted() {
    this.username = this.usernameFromResetPassword;
  },
  methods: {
    redirectToHome() {
      redirect(this.config.eHerkenningCancelPage);
    },
    askForConfirmation() {
      if (!this.isFormValid()) {
        return (this.invalidFormError = true);
      }
      this.invalidFormError = false;
      this.unknownError = "";
      this.$refs.confirmCoupling.open();
    },
    isFormValid() {
      return (
        this.username &&
        this.username.length &&
        this.password &&
        this.password.trim().length
      );
    },
    onKeydown(event) {
      if (
        event &&
        event.getModifierState &&
        event.getModifierState("CapsLock")
      ) {
        document.msCapsLockWarningOff = true;
        this.capsLockInfo =
          "Als de Caps Lock-toets (hoofdletters) aan staat, bestaat de kans dat je het wachtwoord verkeerd invult.";
      } else {
        this.capsLockInfo = "";
      }
    },
    closeModal() {
      this.$refs.confirmCoupling.close();
    },
    async coupleWithEherkenning() {
      this.loading = true;
      this.callForgeRock(this.username, this.password).then(() => {
        this.loading = false;
      });
      this.closeModal();
    },
    async callForgeRock(username, password) {
      try {
        await api.coupleEherkenning(
          this.config.urlEherkenningService,
          username,
          password
        );
        this.$emit("firstTimeCoupled");
      } catch (e) {
        if (e.message === forgeRockCodes.INVALID_CREDENTIAL) {
          this.invalidFormError = true;
          this.failedLoginAttempts += 1;

          if (this.failedLoginAttempts >= FAILED_ATTEMPTS_BEFORE_REDIRECT) {
            this.$router.push({
              name: "ResetPassword",
              params: { config: this.config }
            });
          }
        } else {
          this.$emit("onHandleForgeRockError", e);
        }
      }
    }
  }
};
</script>
